import {
    Component,
    HostBinding,
    Input
} from '@angular/core';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
    selector: 'app-loader',
    standalone: true,
    imports: [ProgressSpinner],
    template: `
        @if (loading) {
            <div class="loader-backdrop flex items-center justify-center">
                <p-progress-spinner></p-progress-spinner>
            </div>
        }
    `,
    styles: [`
        .loader-backdrop {
            position: absolute;
            inset: 0;
            background: rgba(0, 0, 0, 0.25);
            backdrop-filter: blur(3px);
            z-index: 9999;
        }
    `]
})
export class AppLoaderComponent {
    @Input() loading = false;

    @HostBinding('style.z-index')
    get zIndex() {
        return this.loading ? 9999 : null;
    }

    @HostBinding('style.position')
    get position() {
        return this.isInsideModal() || !this.loading ? 'relative' : 'fixed';
    }

    @HostBinding('style.inset')
    get inset() {
        return this.isInsideModal() ? null : '0';
    }

    private isInsideModal(): boolean {
        return !!document.querySelector('.p-dialog-mask.p-component-overlay-visible');
    }
}
